module.exports = __webpack_public_path__ + "static/media/edu4.a1682a9d.jpg";